import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../modules/shared/models/app-config';
import { IGroupContainer } from '../modules/shared/models/group-edit-config';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
    help: any[] = [];

    constructor(private http: HttpClient) { 
        // const url = `${AppConfig.settings.apiHelp}/FixedAssetRegister`;
        // this.http.get<any[]>(url).subscribe(h => {
        //     this.help = h;
        // });
    }

    findTooltips(config: IGroupContainer){
        // config.groups.forEach(group => {
        //     group.sections.forEach(section => {
        //         section.items.forEach(item => {
        //             if(item.tooltipKey){
        //                 const helpItem = this.help.find(x=>x.discriminator === item.tooltipKey);
        //                 if(helpItem){
        //                     item.tooltip = helpItem.body;
        //                 }
        //             }
        //         });
        //     });
        // });
    }
}
